
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosambhajinagar() {



  const cardData =
  {
    keyword: 'Pune to Sambhaji Nagar Taxi Fare',
    heading: 'AB Ghule Cabs: Pune to Sambhaji Nagar Taxi Fare',
    headingDescription: 'Planning a trip to Sambhaji Nagar from Pune? AB Ghule Cabs offers reliable, comfortable, and affordable taxi services to ensure your journey is smooth and hassle-free. Whether it is a business trip, leisure travel, or a family outing, we provide a range of vehicles with professional drivers to make your trip enjoyable. The approximate distance from Pune to Sambhaji Nagar (Aurangabad) is around 230 km.',

    top: 'Top Places to Visit in Sambhaji Nagar with AB Ghule Cabs',

    "topPlaces": [
  {
    title: "Bibi Ka Maqbara",
    description: "The Bibi Ka Maqbara is a beautiful monument often referred to as the 'Taj of the Deccan.' This stunning structure is dedicated to the wife of Aurangzeb, and its resemblance to the Taj Mahal makes it a must-visit for history and architecture lovers."
  },
  {
    title: "Aurangabad Caves",
    description: "These ancient rock-cut caves are a mix of Buddhist and Jain architecture, making them a unique historical site. Located on a hill, the caves offer fascinating sculptures and peaceful surroundings."
  },
  {
    title: "Daulatabad Fort",
    description: "A historic fort that dates back to the 12th century, Daulatabad Fort is known for its strategic location and impressive architecture. It offers panoramic views of the surrounding landscape."
  },
  {
    title: "Ellora Caves",
    description: "The Ellora Caves are a UNESCO World Heritage site famous for their rock-cut temples, monasteries, and caves. It’s a remarkable fusion of Hindu, Buddhist, and Jain art and architecture."
  },
  {
    title: "Grishneshwar Temple",
    description: "One of the twelve Jyotirlingas of Lord Shiva, Grishneshwar Temple is an important pilgrimage site for devotees. The temple’s serene environment makes it a spiritual retreat."
  },
  {
    title: "Jami Masjid",
    description: "This historical mosque is an architectural marvel, featuring intricate carvings and a grand structure. It’s an excellent example of Mughal architecture in the region."
  },
  {
    title: "Shirdi Sai Baba Temple",
    description: "Shirdi is just a short distance from Sambhaji Nagar. The Sai Baba Temple is a renowned spiritual destination where millions of devotees come to seek blessings."
  },
  {
    title: "Meghdoot Garden",
    description: "A peaceful, lush green garden perfect for a relaxing day out. It offers scenic views, picnic spots, and a tranquil atmosphere to unwind and enjoy nature."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Museum",
    description: "This museum is dedicated to the legacy of Chhatrapati Shivaji Maharaj, offering insights into his life, battles, and the Maratha Empire."
  },
  {
    title: "Panchakki",
    description: "An ancient water mill, Panchakki is a marvel of engineering and history. It was used to grind grains and is an interesting site for those fascinated by historical technology."
  }
],


services: [
    {
      "name": "Pune to Sambhaji Nagar Taxi Fare",
      description: "Looking for a reliable taxi service from Pune to Sambhaji Nagar (Aurangabad)? AB Ghule Cabs offers competitive taxi fares to ensure a comfortable and affordable journey. Our pricing is transparent and designed to give you the best value for your trip."
    },
    {
      "name": "Pune to Sambhaji Nagar Cab Charges",
      description: "Get the best cab charges for your trip from Pune to Sambhaji Nagar with AB Ghule Cabs. Our rates are tailored to ensure that you get a budget-friendly and convenient ride for your long-distance travel. Book your cab today for a seamless experience."
    },
    {
      "name": "Pune to Sambhaji Nagar Taxi Booking",
      description: "Book your taxi from Pune to Sambhaji Nagar (Aurangabad) with AB Ghule Cabs. We offer easy online booking for both one-way and round-trip journeys. Enjoy a comfortable ride with our well-maintained fleet of vehicles."
    },
    {
      "name": "Pune to Sambhaji Nagar Car Rental",
      description: "Rent a car from Pune to Sambhaji Nagar (Aurangabad) for a smooth and hassle-free journey. AB Ghule Cabs offers a variety of rental options, including sedans, SUVs, and luxury cars. Whether it's a personal or business trip, we have the right car rental solution for you."
    },
    {
      "name": "Pune to Sambhaji Nagar Taxi Rates",
      description: "Our taxi rates for the Pune to Sambhaji Nagar route are designed to provide maximum value without compromising on comfort. We ensure no hidden charges and offer flexible payment options, making your trip worry-free."
    },
    {
      "name": "Pune to Sambhaji Nagar Cab Pricing",
      description: "AB Ghule Cabs offers affordable and transparent cab pricing for your trip to Sambhaji Nagar (Aurangabad). Whether it's a one-way or round-trip booking, we provide competitive pricing to fit your budget."
    },
    {
      "name": "Pune to Sambhaji Nagar Private Car Hire",
      description: "Looking for a private car for your trip to Sambhaji Nagar (Aurangabad)? We offer private car hire services from Pune to Sambhaji Nagar, ensuring that you travel in comfort and style. Choose from a variety of vehicles including sedans, SUVs, and luxury cars."
    },
    {
      "name": "Pune to Sambhaji Nagar Cab Cost",
      description: "Check out the cab cost from Pune to Sambhaji Nagar with AB Ghule Cabs. Our pricing includes all expenses, ensuring that you pay a fixed price without any hidden charges. Enjoy a stress-free ride with our all-inclusive fare structure."
    },
    {
      "name": "Pune to Sambhaji Nagar Taxi Service Charges",
      description: "At AB Ghule Cabs, we offer competitive taxi service charges for your trip to Sambhaji Nagar (Aurangabad). Whether you're booking a one-way or round-trip journey, we provide the best rates for your comfort and convenience."
    },
    {
      "name": "Pune to Sambhaji Nagar Travel Fare",
      description: "Book your trip from Pune to Sambhaji Nagar (Aurangabad) with AB Ghule Cabs at an affordable travel fare. We provide a smooth and comfortable ride with fixed pricing to make your journey cost-effective."
    },
    {
      "name": "Pune to Sambhaji Nagar Cab Booking Online",
      description: "Book your cab online for a trip from Pune to Sambhaji Nagar with AB Ghule Cabs. Our easy-to-use online booking platform allows you to reserve your taxi in just a few clicks. Enjoy quick and secure booking with flexible payment options."
    },
    {
      "name": "Pune to Sambhaji Nagar One-Way Taxi Fare",
      description: "Looking for a one-way taxi from Pune to Sambhaji Nagar (Aurangabad)? AB Ghule Cabs offers special rates for one-way trips, ensuring that you get the best fare for a direct journey to your destination."
    },
    {
      "name": "Pune to Aurangabad Cab",
      description: "Traveling from Pune to Aurangabad? Book a comfortable and reliable taxi with AB Ghule Cabs. Our fleet includes well-maintained vehicles, ensuring a smooth ride to your destination."
    },
    {
      "name": "Pune to Aurangabad Taxi Fare",
      description: "Check out the affordable taxi fare from Pune to Aurangabad with AB Ghule Cabs. We provide clear and competitive pricing to ensure a hassle-free travel experience."
    },
    {
      "name": "Pune to Aurangabad Cab One Way",
      description: "Need a one-way cab from Pune to Aurangabad? AB Ghule Cabs offers competitive pricing for one-way trips, ensuring a budget-friendly ride without compromising on comfort."
    },
    {
      "name": "Pune to Aurangabad Daily Taxi",
      description: "If you're looking for daily taxi services between Pune and Aurangabad, AB Ghule Cabs provides convenient and affordable options. We offer daily taxi services to suit your regular travel needs."
    },
    {
      "name": "Pune to Aurangabad Taxi Drop",
      description: "Book a drop-off taxi service from Pune to Aurangabad with AB Ghule Cabs. We provide convenient pick-up and drop-off services with flexible timing to make your trip comfortable."
    },
    {
      "name": "Pune to Aurangabad Cab Service",
      description: "AB Ghule Cabs offers reliable cab services from Pune to Aurangabad with comfortable vehicles and experienced drivers. Book your cab for a stress-free journey to Aurangabad today."
    },
    {
      "name": "Pune to Aurangabad Cab Booking",
      description: "Book your cab from Pune to Aurangabad easily with AB Ghule Cabs. We offer online booking with no hidden charges, ensuring a convenient booking experience for your trip."
    },
    {
      "name": "Pune to Aurangabad Cab Price",
      description: "Check the price for your Pune to Aurangabad taxi ride. AB Ghule Cabs provides clear and affordable pricing, ensuring that your journey is both comfortable and economical."
    },
    {
      "name": "Pune to Aurangabad Car Rental",
      description: "Rent a car for your trip from Pune to Aurangabad with AB Ghule Cabs. We offer a variety of vehicles, from sedans to SUVs, for a comfortable and convenient ride."
    },
    {
      "name": "Pune to Aurangabad One-Way Taxi",
      description: "For a one-way taxi service from Pune to Aurangabad, book with AB Ghule Cabs. Our one-way services are designed to provide the best rates and comfort for your trip."
    },
    {
      "name": "Pune to Aurangabad Taxi Service",
      description: "AB Ghule Cabs offers the best taxi services for your trip from Pune to Aurangabad. Whether it's a single journey or multiple days of travel, our taxis provide a smooth and comfortable ride."
    },
    {
      "name": "Pune to Sambhaji Nagar Taxi fare Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Sambhaji Nagar Taxi fare. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pune to Sambhaji Nagar Taxi Fare", "- Pune to Sambhaji Nagar Cab Charges"],
    ["Pune to Sambhaji Nagar Taxi Booking", "- Pune to Sambhaji Nagar Car Rental"],
    ["Pune to Sambhaji Nagar Taxi Rates", "- Pune to Sambhaji Nagar Cab Pricing"],
    ["Pune to Sambhaji Nagar Private Car Hire", "- Pune to Sambhaji Nagar Cab Cost"],
    ["Pune to Sambhaji Nagar Taxi Service Charges", "- Pune to Sambhaji Nagar Travel Fare"],
    ["Pune to Sambhaji Nagar Cab Booking Online", "- Pune to Sambhaji Nagar One-Way Taxi Fare"],
    ["Pune to Aurangabad Cab", "- Pune to Aurangabad Taxi"],
    ["Pune to Aurangabad Taxi Fare", "- Pune to Aurangabad Cab One Way"],
    ["Pune to Aurangabad Daily Taxi", "- Pune to Aurangabad Taxi Drop"],
    ["Pune to Aurangabad Cab Fare", "- Pune Aurangabad Cab Service"],
    ["Pune to Aurangabad Cab Booking", "- Pune to Aurangabad Cab Price"],
    ["Pune to Aurangabad Cab Service Rates", "- Pune to Aurangabad Car Rental"],
    ["Pune to Aurangabad One Way Taxi", "- Pune to Aurangabad Taxi Service"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Affordable Service",
      WhyChoosedescription: "We offer affordable and reliable taxi services from Pune to Sambhaji Nagar. Whether you're traveling for business or leisure, we ensure that your journey is comfortable and budget-friendly."
    },
    {
      WhyChooseheading: "Competitive and Transparent Pricing",
      WhyChoosedescription: "Our taxi fares are designed to offer the best value for your money. With AB Ghule Cabs, there are no hidden charges—just simple, transparent pricing. We aim to provide competitive fares for both short and long-distance journeys."
    },
    {
      WhyChooseheading: "Comfortable and Well-Maintained Vehicles",
      WhyChoosedescription: "Our vehicles are regularly cleaned and well-maintained to ensure you have a smooth and pleasant ride. Whether you're traveling in a sedan, SUV, or luxury car, we provide comfortable options to suit your preferences."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our professional drivers are experienced, courteous, and knowledgeable about the best routes. They are committed to ensuring your safety and comfort throughout the journey, so you can relax and enjoy the ride."
    },
    {
      WhyChooseheading: "On-Time Pick-Up and Drop-Off",
      WhyChoosedescription: "At AB Ghule Cabs, we understand the importance of punctuality. We guarantee on-time pick-up and drop-off services for your trip from Pune to Sambhaji Nagar, so you never have to worry about being late."
    },
    {
      WhyChooseheading: "Easy and Convenient Booking Process",
      WhyChoosedescription: "Booking a taxi from Pune to Sambhaji Nagar is quick and easy. You can book online via our website or mobile app, or simply call our customer service for instant assistance."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Our services are available round-the-clock. Whether you need a ride early in the morning or late at night, we are always ready to serve you with punctual and reliable taxi services."
    }
  ]
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a taxi from Pune to Sambhaji Nagar?',
      answer: 'You can book your taxi easily through our website, mobile app, or by calling our customer service team.',
    },
    {
      id: 'FAQ2',
      question: 'What is the fare for a one-way trip from Pune to Sambhaji Nagar?',
      answer: 'The one-way fare for a sedan typically ranges from ₹2,500 to ₹3,000. The actual fare depends on factors like vehicle type and travel conditions.',
    },
    {
      id: 'FAQ3',
      question: 'Are the fares inclusive of taxes and tolls?',
      answer: 'Yes, our quoted fares include taxes, tolls, and other applicable charges. There are no hidden fees.',
    },
    {
      id: 'FAQ4',
      question: 'How long will the journey from Pune to Sambhaji Nagar take?',
      answer: 'The travel time is approximately 2.5 to 3 hours, depending on traffic conditions.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round trip from Pune to Sambhaji Nagar?',
      answer: 'Yes, we offer round-trip bookings at competitive rates. You can contact our team for customized fare details.',
    },
    {
      id: 'FAQ6',
      question: 'Do you offer a pick-up from my location in Pune?',
      answer: 'Yes, we provide convenient pick-up from any location in Pune, including hotels, residences, or business locations.',
    },
    {
      id: 'FAQ7',
      question: 'Are the vehicles air-conditioned?',
      answer: 'Yes, all our vehicles are fully air-conditioned for a comfortable ride, especially during long journeys.',
    },
    {
      id: 'FAQ8',
      question: 'Can I choose the type of vehicle for my trip?',
      answer: 'Yes, you can select from a range of vehicles, including sedans, SUVs, and luxury cars, based on your preferences and group size.',
    },
    {
      id: 'FAQ9',
      question: 'How do I pay for the taxi service?',
      answer: 'Payments can be made via cash, credit/debit card, or through our mobile app for your convenience.',
    },
    {
      id: 'FAQ10',
      question: 'Is there any extra charge for waiting time or detours?',
      answer: 'Extra charges may apply for waiting time or detours, depending on the nature of the trip. These charges will be communicated in advance.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Rahul Deshmukh',
      feedback: 'I traveled from Pune to Sambhaji Nagar with AB Ghule Cabs, and I must say the experience was wonderful. The car was clean, and the driver was very professional. The journey was smooth, and the pricing was reasonable. Highly recommend them for long-distance travel!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Shweta Joshi',
      feedback: 'Booking a taxi with AB Ghule Cabs for my trip to Sambhaji Nagar was simple and hassle-free. The driver was on time, and the car was comfortable. I will definitely use their services for my future trips.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Sambhaji Nagar Taxi Fare | Affordable Cab & Car Rental Services</title>
  <meta name="description" content="Book a taxi from Pune to Sambhaji Nagar with AB Ghule Cabs. Get the best fares for one-way and round trip cabs, including Aurangabad. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Sambhaji Nagar Taxi Fare, Pune to Sambhaji Nagar Cab Charges, Pune to Sambhaji Nagar Taxi Booking, Pune to Sambhaji Nagar Car Rental, Pune to Sambhaji Nagar Taxi Rates, Pune to Sambhaji Nagar Cab Pricing, Pune to Sambhaji Nagar Private Car Hire, Pune to Sambhaji Nagar Cab Cost, Pune to Sambhaji Nagar Taxi Service Charges, Pune to Sambhaji Nagar Travel Fare, Pune to Sambhaji Nagar Cab Booking Online, Pune to Sambhaji Nagar One-Way Taxi Fare, Pune to Aurangabad Cab, Pune to Aurangabad Taxi, Pune to Aurangabad Taxi Fare, Pune to Aurangabad Cab One Way, Pune to Aurangabad Daily Taxi, Pune to Aurangabad Taxi Drop, Pune to Aurangabad Cab Fare, Pune Aurangabad Cab Service, Pune to Aurangabad Cab Booking, Pune to Aurangabad Cab Price, Pune to Aurangabad Cab Service Rates, Pune to Aurangabad Car Rental, Pune to Aurangabad One Way Taxi, Pune to Aurangabad Taxi Service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Sambhaji Nagar Taxi Fare | Affordable Cab & Car Rental Services" />
  <meta property="og:description" content="Book a taxi from Pune to Sambhaji Nagar with AB Ghule Cabs. Get the best fares for one-way and round trip cabs, including Aurangabad. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-sambhaji-nagar-taxi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-sambhaji-nagar-taxi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Sambhaji Nagar Taxi",
        description: "Book a taxi from Pune to Sambhaji Nagar with AB Ghule Cabs. Get the best fares for one-way and round trip cabs, including Aurangabad. Affordable car rental services available. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-sambhaji-nagar-taxi",
        "logo": "https://abghulecabs.com/images/pune-to-sambhaji-nagar-taxi.jpg",
        "image": "https://abghulecabs.com/images/pune-to-sambhaji-nagar-taxi.jpg",
        "priceRange": "₹2000 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-sambhaji-nagar-taxi",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "95"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi K"
            },
            "datePublished": "2024-11-10",
            "reviewBody": "The Pune to Sambhaji Nagar taxi service was excellent! Comfortable ride and the driver was punctual. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha S"
            },
            "datePublished": "2024-09-21",
            "reviewBody": "I booked a cab from Pune to Aurangabad, and it was smooth and affordable. The cab was in great condition, and the driver was courteous."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Sambhaji Nagar Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-sambhaji-nagar-taxi"
        },
        "keywords": "Pune to Sambhaji Nagar Taxi Fare, Pune to Sambhaji Nagar Cab Charges, Pune to Sambhaji Nagar Taxi Booking, Pune to Sambhaji Nagar Car Rental, Pune to Sambhaji Nagar Taxi Rates, Pune to Sambhaji Nagar Cab Pricing, Pune to Sambhaji Nagar Private Car Hire, Pune to Sambhaji Nagar Cab Cost, Pune to Sambhaji Nagar Taxi Service Charges, Pune to Sambhaji Nagar Travel Fare, Pune to Sambhaji Nagar Cab Booking Online, Pune to Sambhaji Nagar One-Way Taxi Fare, Pune to Aurangabad Cab, Pune to Aurangabad Taxi, Pune to Aurangabad Taxi Fare, Pune to Aurangabad Cab One Way, Pune to Aurangabad Daily Taxi, Pune to Aurangabad Taxi Drop, Pune to Aurangabad Cab Fare, Pune Aurangabad Cab Service, Pune to Aurangabad Cab Booking, Pune to Aurangabad Cab Price, Pune to Aurangabad Cab Service Rates, Pune to Aurangabad Car Rental, Pune to Aurangabad One Way Taxi, Pune to Aurangabad Taxi Service"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/49.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetosambhajinagar;